import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { SupplierBillService, SupplierBillData, Justification, ChargeNote } from '../../services/supplier-bill.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { PurchaseOrderService, PrForOrders, PurchaseOrderId } from '../../services/purchase-order.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { ExpenseCategoryService, ExpenseCategory } from '../../services/expense-category.service';
import { ExpenseConceptService, ExpenseConcept } from '../../services/expense-concept.service';
import { SelectOption } from '../../globals';
import { CustomerBillData } from '../../services/customer-bill.service';

@Component({
  selector: 'app-update-supplier-bill',
  templateUrl: './update-supplier-bill.component.html',
  styleUrls: ['./update-supplier-bill.component.css']
})
export class UpdateSupplierBillComponent implements OnInit, OnDestroy {

  supplierBillId: string;
  supplierId: string;
  fiscalDataId: string;
  fiscalData:any = {};

  supplierBillForm: FormGroup;
  currencySelect: SelectOption[] = [];

  purchaseOrders = {};

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  pickadateParams = Utils.pickadateParams();

  subtractedOdcIds: string[] = [];

  subs = [];

  constructor(
    private service: SupplierBillService,
		private fiscalDataService: FiscalDataService,
    private purchaseOrderService: PurchaseOrderService,
    private supplierBillData: SupplierBillData,
    private billData: CustomerBillData,
    private expenseCategoryService: ExpenseCategoryService,
    private expenseConceptService: ExpenseConceptService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.supplierBillId = this.activatedRoute.snapshot.paramMap.get('id');
    this.supplierId = this.activatedRoute.snapshot.paramMap.get('supplierId');
    this.fiscalDataId = this.activatedRoute.snapshot.paramMap.get('fiscalDataId');

    let expenseCategorySub = this.expenseCategoryService.getExpenseCategorys().subscribe(categorys => {
      expenseCategorySub.unsubscribe();
      this.justificationCategorySelect = [
        ...this.supplierBillData.justificationCategorySelect,
        ...categorys.map(category => {
          let {name} = category, value = name;
          this.expenseCategorysByName[name] = category;
          return {name, value};
        }),
      ];
    });

    let expenseConceptSub = this.expenseConceptService.getExpenseConcepts().subscribe(concepts => {
      expenseConceptSub.unsubscribe();
      for(let concept of concepts){
        let {id, expenseCategoryRef: {id: categoryId}} = concept;
        this.expenseConcepts[id] = concept;

        if(!this.expenseConceptsByCategoryId[categoryId]) this.expenseConceptsByCategoryId[categoryId] = [concept];
        else this.expenseConceptsByCategoryId[categoryId].push(concept);
      }
    });

    this.justificationCategorySelect = supplierBillData.justificationCategorySelect;
    this.justifications = [];

    this.subs[0] = this.fiscalDataService.getFiscalData(this.fiscalDataId).subscribe((fiscalData) => {
      this.fiscalData = {...fiscalData};
    });

  }

  ngOnInit() {
    this.createForm();
    let supSub = this.service.getSupplierBill(this.supplierBillId).subscribe(([supplierBill]) => {
      supSub.unsubscribe();
      this.supplierBillForm.patchValue(supplierBill);
      this.startFolio = supplierBill.folio;
      this.justifications = supplierBill.justifications;
      this.chargeNotes = supplierBill.chargeNotes;
      
      this.purchaseOrders = {};
      this.subs[1] = this.purchaseOrderService.getPurchaseOrders().subscribe(purchaseOrders => {
        this.rJust_rowsRead[0] = purchaseOrders.filter(purchaseOrder => {
          this.purchaseOrders[purchaseOrder.id] = {...purchaseOrder};
          purchaseOrder.name = purchaseOrder.folio;
          purchaseOrder.prNum = purchaseOrder.prForOrders.length;
          purchaseOrder.prForOrders.map(pr => {
            if(!pr.uniqueId) return;
            this.justifications.map(just => {
              if(!just.__prForOrderBilled || !+just.__prForOrderBilled[pr.uniqueId]) return;
              Utils.cleanPush(this.subtractedOdcIds, purchaseOrder.id);
              pr.billedQuantity -= +just.__prForOrderBilled[pr.uniqueId];
            });
          });
          return purchaseOrder.fiscalDataObj.id == this.fiscalDataId;
        });
      });

    });
  }
	ngOnDestroy() {
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm(){
    this.currencySelect = this.billData.allSelects.currency;
    this.supplierBillForm = this.fb.group({
      folio: ['', Validators.required],
      date: ['', Validators.required],
      subtotal: ['', [Validators.required, Validators.min(0)]],
      iva: ['', [Validators.required, Validators.min(0)]],
      total: ['', [Validators.required, Validators.min(0)]],
      payDate: ['', [Validators.required]],
      retentionIVA: [0, Validators.required],
      retentionISR: [0, Validators.required],
      currency: [this.currencySelect[0].value, Validators.required],
      change: [1, Validators.required],
    });
  }

  onSubmit({ value, valid }: { value: any, valid: any }){

    value.supplierRef = this.supplierId;
    value.fiscalDataRef = this.fiscalData.id;
    value.justifications = this.justifications;
    value.chargeNotes = this.chargeNotes;
    value.chargeNoteTotal = this.chargeNotesTotal;
    
    
    let odcsToUpdate: {[id: string]: PrForOrders[]} = {};
    for(let just of this.justifications){
      let odcId = just.purchaseOrderRef;
      if(!odcId) continue;
      if(!odcsToUpdate[odcId]) odcsToUpdate[odcId] = [...this.purchaseOrders[odcId].prForOrders];
      odcsToUpdate[odcId] = odcsToUpdate[odcId].map(({billedQuantity=0, ...pr}, index) => {
        delete pr['billQuantity'];
        billedQuantity += just.__prForOrderBilled[pr.uniqueId] || 0;
        return {billedQuantity, ...pr};
      });
    }
    for(let odcId of this.subtractedOdcIds) if(!odcsToUpdate[odcId]) odcsToUpdate[odcId] = [...this.purchaseOrders[odcId].prForOrders];

    this.service.updateSupplierBill(this.supplierBillId, value);
    for(let odcId in odcsToUpdate){
      this.purchaseOrderService.updatePurchaseOrder(odcId, {prForOrders: odcsToUpdate[odcId]})
    }
    this.service.windowReplace('read');
  }

  onChangeCurrency(){
    if(this.supplierBillForm.get('currency').value == 'key0') this.supplierBillForm.get('change').patchValue(1);
    else{
      this.supplierBillForm.get('iva').patchValue(0);
      this.onInputSubtotal();
    }
  }


  folioMessage: string = '';
  startFolio: string;
  async verifyFolio(){
    let folio = `${this.supplierBillForm.get('folio').value}`;
    if(this.startFolio == folio){
      this.folioMessage = '';
      return;
    }
    let folioIsRepeated = await this.service.folioExistsForSupplier(folio, this.supplierId);
    this.folioMessage = !folioIsRepeated ? '' : 'Este folio ya fue usado en otra factura previamente por lo que se asume fue capturada anteriormente.';
  }

  onChangeDate(date){
    const payDate = date ? this.stringifyDate(new Date( new Date(date).getTime() + (this.fiscalData.creditLimitDays+1) * 86400000 )) : '';
    this.supplierBillForm.get('payDate').patchValue(payDate);
  }
  onInputSubtotal(){
    let subtotal = +this.supplierBillForm.get('subtotal').value;
    let retentionISR = +this.supplierBillForm.get('retentionISR').value;
    let retentionIVA = +this.supplierBillForm.get('retentionIVA').value;
    this.supplierBillForm.get('total').patchValue(+(subtotal * (1 + this.docIva/100) - retentionISR - retentionIVA).toFixed(2));
  }
  onInputTotal(){
    let total = +this.supplierBillForm.get('total').value;
    let retentionISR = +this.supplierBillForm.get('retentionISR').value;
    let retentionIVA = +this.supplierBillForm.get('retentionIVA').value;
    let subtotal = (total + retentionISR + retentionIVA) / (1 + this.docIva/100);
    this.supplierBillForm.get('subtotal').patchValue(+(subtotal).toFixed(2));
  }
  get docIva(){ return this.supplierBillForm.get('iva').value; }


  money = Utils.money;

  stringifyDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////JUSTIFICATIONS
  justification = {} as Justification;
  justifications: Justification[];
  justificationCategorySelect: {name: string, value: string}[];
  
  expenseConcepts: {[id: string]: ExpenseConcept} = {};
  expenseCategorysByName: {[name: string]: ExpenseCategory} = {};
  expenseConceptsByCategoryId: {[id: string]: ExpenseConcept[]} = {};
  currentConceptSelect: {name: string, value: string}[];

  modalOffersOdc: boolean = false;

  modalActionsJustification = new EventEmitter<string|MaterializeAction>();
  modalParamsJustification = [{dismissible: true}];
  get justificationIsValid(){
    const {concept, price} = this.justification;
    //list of validators
    return !(
      !concept ||
      isNaN(price)
    )
  }
  get justificationsTotal(): number {
    return this.justifications.reduce((total, {price}) => total + price, 0);
  }
  get justificationsTotalIsValid(){
    return Math.floor(this.justificationsTotal) == Math.floor(this.supplierBillForm.get('subtotal').value);
  }
  get justificationHasPurchaseOrder(){
    return !!this.justification.purchaseOrderRef;
  }
  
  currentEditingIndexJustification: number = -1;
  openModalJustification(index?: number) {
    {
      this.rJust_data = this.rJust_rowsRead[0];
      this.rJust_config = this.rJust_configs[0];
      this.rJust_onChangeTable(this.rJust_config);
    }
    this.currentEditingIndexJustification = index;
    this.justification = index != undefined ? {...this.justifications[this.currentEditingIndexJustification]} : {} as Justification;
    this.modalOffersOdc = this.justificationHasPurchaseOrder;
    if(this.modalOffersOdc && this.justification.__prForOrderBilled){
      for(let pr of this.purchaseOrders[this.justification.purchaseOrderRef].prForOrders){
        pr['billQuantity'] = pr.uniqueId && this.justification.__prForOrderBilled[pr.uniqueId] || 0;
      }
    }
    this.onChangeJustificationConcept(this.justification.concept);
    this.modalActionsJustification.emit({ action: 'modal', params: ['open'] });
  }
  closeModalJustification() {
    this.modalActionsJustification.emit({ action: 'modal', params: ['close'] });
  }

  onChangeJustificationConcept(value){
    this.rJust_show.delete(0);
    this.currentConceptSelect = undefined;
    if(value == 'Orden de compra'){
      this.rJust_show.add(0);
    }else if(value){
      let category = this.expenseCategorysByName[value];
      if(!category) return;
      let concepts = this.expenseConceptsByCategoryId[category.id] || [];
      if(!concepts.length){
        this.justification.concept = '';
        return toast(`No hay gastos en esta categoría.`, 2000);
      }
      this.currentConceptSelect = [
        {name: 'Sin definir', value: 'undefined'},
        ...concepts.map(({id: value, name}) => ({name, value})),
      ];
    }
  }
  
  touchJustification(){
    if(!this.justificationHasPurchaseOrder || !this.modalOffersOdc) this.justification.purchaseOrderRef = '';
    else this.justification.__prForOrderBilled = this.purchaseOrders[this.justification.purchaseOrderRef].prForOrders.reduce((acc,cur) => {
      if(+cur['billQuantity'] && cur['uniqueId']) acc[cur['uniqueId']] = cur['billQuantity'];
      return acc;
    }, {});

    if(this.currentEditingIndexJustification == undefined) this.justifications.push({...this.justification});
    else this.justifications[this.currentEditingIndexJustification] = {...this.justification};
    this.closeModalJustification();
  }
  removeJustification(index) {
    this.justifications.splice(index,1);
  }

  odcProductInput(odcProducts: PrForOrders[]){
    let price = 0;
    for(let pr of odcProducts) if(+pr['billQuantity']) price += pr['billQuantity'] * pr.pricePerUnit;
    this.justification.price = price;
  }

  //////////////////////////////////////////////////////////////////////////READ MODAL DATA
  rJust_show = new Set([]);
  rJust_selectRead({row}){
    this.justification.purchaseOrderRef = row.id;
    this.justification.price = row.total;
  }

  rJust_rowsRead = [[]];
  rJust_columnsRead = [
    [
      {title: 'Folio', className: 'center', name: 'name'},
      {title: 'Fecha' , className: 'center', name: 'date'},
      {title: 'Cantidad de productos', className: 'center', name: 'prNum'},
    ]
  ]


  rJust_data:Array<any>;
  rJust_rows:Array<any> = [];
  rJust_page:number = 1;
  rJust_itemsPerPage:number = 5;
  rJust_maxSize:number = 5;
  rJust_numPages:number = 1;
  rJust_length:number = 0;

  
  rJust_configs:any = this.rJust_columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  rJust_config;

  /*********** Filter, sort, and pagination */

	rJust_changePage(page:any, data:Array<any> = this.rJust_rowsRead[0]):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  rJust_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.rJust_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }


  rJust_changeFilter(data:any = this.rJust_rowsRead[0], config:any):any {
    //console.clear();
    console.log(this.rJust_columnsRead[0])
    let filteredData:Array<any> = data;
    this.rJust_columnsRead[0].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.rJust_config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.rJust_columnsRead[0].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.rJust_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  rJust_onChangeTable(config:any, page:any = {page: this.rJust_page, itemsPerPage: this.rJust_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.rJust_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.rJust_config.sorting, config.sorting);
    }

    let filteredData = this.rJust_changeFilter(this.rJust_rowsRead[0], this.rJust_config);
    let sortedData = this.rJust_changeSort(filteredData, this.rJust_config);
    this.rJust_rows = page && config.paging ? this.rJust_changePage(page, sortedData) : sortedData;
    this.rJust_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////READ MODAL DATA

  //////////////////////////////////////////////////////////////////////////////////////////////JUSTIFICATIONS

  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE
  modalActionsChargeNote = new EventEmitter<string|MaterializeAction>();
  modalParamsChargeNote = [{dismissible: true}];
  
  chargeNote: ChargeNote = {...this.service.defaultChargeNote};
  chargeNotes: ChargeNote[] = [];
  get chargeNoteIsValid(): boolean {
    return !!(
      this.chargeNote.date &&
      this.chargeNote.total
    )
  }
  get chargeNotesTotal(): number { return this.chargeNotes.reduce((acc,{total}) => acc + total, 0) }

  onInputSubtotalCharge(){
    let {subtotal} = this.chargeNote;
    this.chargeNote.total = +(subtotal * 1.16).toFixed(2);
    this.chargeNote.iva = +(subtotal * .16).toFixed(2);
  }
  onInputTotalCharge(){
    let subtotal = this.chargeNote.total / 1.16;
    this.chargeNote.subtotal= +subtotal.toFixed(2);
    this.chargeNote.iva= +(subtotal * .16).toFixed(2);
  }
  
  currentEditingIndexChargeNote: number;
  openModalChargeNote(editingIndex?: number) {
    this.currentEditingIndexChargeNote = editingIndex;
    this.chargeNote = editingIndex == undefined ? {...this.service.defaultChargeNote} : {...this.chargeNotes[editingIndex]};
    this.modalActionsChargeNote.emit({ action: 'modal', params: ['open'] });
  }
  closeModalChargeNote() {
    this.modalActionsChargeNote.emit({ action: 'modal', params: ['close'] });
  }
  
  touchChargeNote(){
    if(this.currentEditingIndexChargeNote == undefined) this.chargeNotes.push( {...this.chargeNote} );
    else this.chargeNotes[this.currentEditingIndexChargeNote] = {...this.chargeNote};
    this.closeModalChargeNote();
  }
  removeChargeNote(index) {
    this.chargeNotes.splice(index,1);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////CREDIT_NOTE

}